import React, { Fragment, useEffect } from "react";
import Informational from "../../Common/components/Informational";
import ExternalLink from "../../Common/components/ExternalLink";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectOauthRedirectPath } from "../../services/authorization/slices";
import { Mui } from "@osu/react-ui";
import { handleLogin } from "../../services/authorization/thunks";

function LogIn() {
  const { authStatus } = useAuthenticator(
    (context) => [context.authStatus]
  );
  const [searchParms] = useSearchParams();
  const cognitoCode = searchParms.get("code");
  const customOAuthStateRedirect = searchParms.get("from");
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const redirectPath = useSelector(state => {
    const _redirectPath = selectOauthRedirectPath(state)
    return _redirectPath
  })
  const redirecting = authStatus === "unauthenticated" && !cognitoCode
  const canNavigateTo = (authStatus === "authenticated" && cognitoCode) && (redirectPath || "/")

  useEffect(() => {
    if (redirecting) {
      dispatch(handleLogin(customOAuthStateRedirect));
    }
  }, [customOAuthStateRedirect, dispatch, location, navigate, redirecting]);

  useEffect(() => {
    if (!redirecting && canNavigateTo) {
      navigate(canNavigateTo);
    }
  }, [redirecting, canNavigateTo, navigate]);

  if(redirecting) {
    return  <Mui.Typography>
      Redirecting to sign in...
    </Mui.Typography>
  }

  return (
    <Informational
      info={
        <Fragment>
          There was an error signing you in. If this error continues contact us
          at{" "}
          <ExternalLink href="http://help.osu.edu">help.osu.edu</ExternalLink>.
        </Fragment>
      }
    />
  );
}

export default LogIn;
